import ChatIllustration from "@/assets/illustrations/chat-illustration";
import React from "react";
import { Text, View } from "react-native";
import { Button } from "../ui/button";
import { useRouter } from "expo-router";
import ResponsiveContent from "../shared/responsive-content";

function ParentChatEmptyState() {
  const router = useRouter();

  const handleFindTutor = () => {
    router.push("/home/find-tutor");
  };

  return (
    <ResponsiveContent>
      <View className="mx-4 gap-9">
        <View>
          <View className="items-center">
            <ChatIllustration />
          </View>
          <View className="bg-teachLoop-creamDark py-8 px-4 rounded-2xl">
            <Text className="font-geologica-regular font-normal text-base text-black leading-[1.5] text-center">
              Your chat is empty as you don&apos;t have any lessons booked.
              Start by finding a tutor for your child!
            </Text>
          </View>
        </View>

        <View className="items-center">
          <Button size="sm" onPress={handleFindTutor}>
            <Button.Text size="sm">Find a tutor</Button.Text>
          </Button>
        </View>
      </View>
    </ResponsiveContent>
  );
}

export default ParentChatEmptyState;
